/*
* Project: LegalPlace assistant
* File: src/components/misc/shimmer.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React from 'react';

const TitleShimmer = () => (<div className="shimmer ch-titles" />);

const ParagraphShimmer = () => (<div className="shimmer ch-content" />);

const PackShimmer = () => (
  <div className="pack-shimmer">
    <div className="shimmer ch-pack" />
  </div>
);


export {
  TitleShimmer,
  ParagraphShimmer,
  PackShimmer,
};



// WEBPACK FOOTER //
// ./src/components/misc/shimmer.js